import React from 'react'

import EditBuyerForm from '../../modules/Buyer/components/EditBuyerForm'
export default function EditBuyerPage() {
  return <EditBuyerForm />
}
